import { RxDriftMetricsAPI } from '@driftt/dapper'

export const sendDriftAppMetric = (metric) =>
  RxDriftMetricsAPI.post('/monitoring/metrics/add', metric)
    .checkStatus()
    .retryWithBackoff()
